import { render, staticRenderFns } from "./TakingAddSource.vue?vue&type=template&id=ce947b70"
import script from "./TakingAddSource.vue?vue&type=script&lang=js"
export * from "./TakingAddSource.vue?vue&type=script&lang=js"
import style0 from "./TakingAddSource.vue?vue&type=style&index=0&id=ce947b70&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports